import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, input } from '@angular/core';
import { Observable } from 'rxjs';
import { MercerDialogType } from '../../../enums/mercer-dialog-type.enum';
import { MercerEvaluationMember } from '../../../models/mercer-support-evaluation-member.model';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { V2DropdownComponent, DropdownSearchDirective, V2TextInputComponent } from '@coin/shared/core/ui-storybook';
import { TemplateWithValueDirective } from '@coin/shared/core/util-directives';
import { EmployeeNamePipe, PureFunctionPipe, SortAlphabeticallyPipe } from '@coin/shared/core/util-pipes';

@Component({
  selector: 'customer-position-comparisation-filter-list',
  templateUrl: './position-comparisation-filter-list.component.html',
  styleUrls: ['./position-comparisation-filter-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    V2DropdownComponent,
    DropdownSearchDirective,
    FormsModule,
    TemplateWithValueDirective,
    V2TextInputComponent,
    TranslatePipe,
    EmployeeNamePipe,
    PureFunctionPipe,
    SortAlphabeticallyPipe
  ]
})
export class PositionComparisationFilterListComponent {
  readonly isLocked = input<boolean>(undefined);
  readonly isReadOnly = input<boolean>(undefined);
  readonly lazyLoadFn = input<(key: string) => (search: string) => Observable<string[]>>(undefined);
  public readonly dialogType = input<MercerDialogType>(undefined);
  public readonly relatedPositions = input<MercerEvaluationMember[]>(undefined);
  @Input() public selectedOrgLevel: string;
  @Input() public selectedOrgCode: string;

  @Output() public updateRelatedPositions = new EventEmitter<void>();
  @Output() public openPosition = new EventEmitter<MercerEvaluationMember>();
}
